export default __webpack_public_path__ + "static/bannerCarMobile-4cfbccc9c0185aef340d81a44f8bdf26.png";